import React from 'react';
import { Link } from 'react-router-dom';
import '../BitsStyles/Homepage.css';

const BillingHero = () => (
  <section className="billing-hero">
    {/* Background orbs */}
    <div className="bh-orb bh-orb1"></div>
    <div className="bh-orb bh-orb2"></div>

    <div className="bh-inner">
      {/* Text side */}
      <div className="bh-text">
        <div className="bh-eyebrow">
          <i className="bi bi-receipt-cutoff"></i>
          Billing & Invoicing Platform
        </div>
        <h2 className="bh-title">
          Effortless Billing for
          <span className="bh-title-grad"> Smarter Businesses</span>
        </h2>
        <p className="bh-desc">
          Automate invoicing, handle GST compliance, track payments, and generate real-time financial reports — all in one powerful platform designed for Indian businesses.
        </p>
        <ul className="bh-features">
          {[
            { icon: 'bi-check-circle-fill', text: 'Automated GST-compliant invoicing' },
            { icon: 'bi-check-circle-fill', text: 'Real-time payment tracking & analytics' },
            { icon: 'bi-check-circle-fill', text: 'Multi-format reports (PDF, Excel, CSV)' },
            { icon: 'bi-check-circle-fill', text: 'Integrated TDS & tax calculations' },
          ].map((f, i) => (
            <li key={i}><i className={`bi ${f.icon}`}></i> {f.text}</li>
          ))}
        </ul>
        <div className="bh-ctas">
          <Link to="/billing" className="bh-btn-primary">
            Explore Billing Solutions <i className="bi bi-arrow-right"></i>
          </Link>
          <Link to="/contact-bits#contact-form" className="bh-btn-ghost">
            Contact Us
          </Link>
        </div>
      </div>

      {/* Dashboard visual */}
      <div className="bh-visual">
        <div className="bh-dashboard">
          {/* Dashboard top bar */}
          <div className="bh-dash-header">
            <div className="bh-dash-title">
              <i className="bi bi-bar-chart-line-fill"></i>
              Billing Dashboard
            </div>
            <span className="bh-dash-live">
              <span className="bh-live-dot"></span> Live
            </span>
          </div>

          {/* Stats row */}
          <div className="bh-dash-stats">
            {[
              { label: 'Total Revenue', value: '₹12.4L', trend: '+18%', up: true },
              { label: 'Invoices Sent', value: '248', trend: '+32', up: true },
              { label: 'Pending', value: '₹1.2L', trend: '-5%', up: false },
            ].map((s, i) => (
              <div key={i} className="bh-stat">
                <div className="bh-stat-val">{s.value}</div>
                <div className="bh-stat-label">{s.label}</div>
                <div className={`bh-trend ${s.up ? 'up' : 'down'}`}>
                  <i className={`bi ${s.up ? 'bi-arrow-up' : 'bi-arrow-down'}`}></i>
                  {s.trend}
                </div>
              </div>
            ))}
          </div>

          {/* Bar chart */}
          <div className="bh-chart">
            {[65, 80, 55, 90, 72, 85, 60, 95, 78, 88, 70, 100].map((h, i) => (
              <div key={i} className="bh-bar-wrap">
                <div
                  className="bh-bar"
                  style={{ height: `${h}%`, animationDelay: `${i * 0.06}s` }}
                ></div>
              </div>
            ))}
          </div>
          <div className="bh-chart-labels">
            {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m,i) => (
              <span key={i}>{m}</span>
            ))}
          </div>

          {/* Recent invoices */}
          <div className="bh-invoices">
            <div className="bh-inv-title">Recent Invoices</div>
            {[
              { client: 'Tech Corp Ltd', amount: '₹45,000', status: 'paid' },
              { client: 'Sharma Enterprises', amount: '₹28,500', status: 'pending' },
              { client: 'Global Systems', amount: '₹72,000', status: 'paid' },
            ].map((inv, i) => (
              <div key={i} className="bh-inv-row">
                <span className="bh-inv-client">{inv.client}</span>
                <span className="bh-inv-amount">{inv.amount}</span>
                <span className={`bh-inv-status ${inv.status}`}>{inv.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BillingHero;
